import script from "./AppError.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppError.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__